<div class="status-block" [style.border-color]="colorsMapping[status]">
  <span> {{ statusesMapping[status]  }}</span>
</div>